module.exports = __webpack_public_path__ + "img/step03-active.b0fdb252.png";